import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewEncapsulation,
} from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { RecommendedProductsService } from '../../../../services/recommended-products.service';
import { Store } from '@ngrx/store';
import * as fromRecommendedProductsReducer from '../../../../reducers/recommended-products.reducer';
import { Observable } from 'rxjs';
import { ProductOrdersInfo } from '../../../../interfaces/product-orders-info';
import { MobileCheckServiceService } from '../../../../services/mobile-check-service.service';
import { OrderItemService } from '../../../../services/order-item.service';
import { Order } from '../../../../models/order.model';
import { OrderService } from '../../../../services/order.service';

@UntilDestroy()
@Component({
  selector: 'app-product-orders-details',
  templateUrl: './product-orders-details.component.html',
  styleUrls: ['./product-orders-details.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class ProductOrdersDetailsComponent implements OnInit {
  @Input() productId: number;

  @Input() modal = false;

  @Output() showFull = new EventEmitter<void>();

  private _activeOrder: Order;

  constructor(
    private productInfoService: RecommendedProductsService,
    private mobileCheck: MobileCheckServiceService,
    private orderItemService: OrderItemService,
    private orderService: OrderService,
    private store: Store<fromRecommendedProductsReducer.IRecommendedProductsState>
  ) {}

  ngOnInit(): void {
    if (this.productId) {
      this.orderService
        .activeOrderChanged()
        .pipe(untilDestroyed(this))
        .subscribe((order) => {
          if (order && order.id > 0) {
            if (order.id !== this._activeOrder?.id) {
              this.productInfoService.getProductOrdersIfo(this.productId);
              this._activeOrder = order;
            }
          }
        });
    }
  }

  exportToExcel(): void {
    this.productInfoService
      .exportRecommendedProductToExcel(this.productId)
      .pipe(untilDestroyed(this))
      .subscribe((result) => {
        if (result) {
          this.orderItemService.showRecommendedProductExportResult('xlsx');
        }
      });
  }

  exportToPDF(): void {
    this.productInfoService
      .exportRecommendedProductToPDF(this.productId)
      .pipe(untilDestroyed(this))
      .subscribe((result) => {
        if (result) {
          this.orderItemService.showRecommendedProductExportResult('pdf');
        }
      });
  }

  showFullView(): void {
    this.showFull.emit();
  }

  get isFetching$(): Observable<boolean> {
    return this.store.select(
      fromRecommendedProductsReducer.isFetchingProductOrdersInfo
    );
  }

  get ordersDetails$(): Observable<ProductOrdersInfo> {
    return this.store.select(
      fromRecommendedProductsReducer.productOrdersInfoById,
      { id: this.productId }
    );
  }

  get mobile(): boolean {
    return this.mobileCheck.mobileDevice;
  }
}
